import Translate from "@casino/legacy/client/shared/i18n/Translate";
import useTermsUrl from "@casino/legacy/client/shared/TermsAndConditions/useTermsUrl";
import { TypographyText } from "@workspace/frontend-ui";

const TermsLink: FC = () => {
  const termsUrl = useTermsUrl();
  return (
    <a
      href={termsUrl}
      className="inline cursor-pointer bg-transparent p-0 font-[inherit] text-primary no-underline"
      target="_blank"
      rel="noopener noreferrer"
    >
      <TypographyText as="span" variant="small">
        <Translate id="profile.terms_and_conditions" />
      </TypographyText>
    </a>
  );
};

export default TermsLink;
